import { Component } from '@verndale/core';

import { truncate } from '../utils/text';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $titles: this.el._$$('.resources-content-cards__single-card-title'),
      $descriptions: this.el._$$(
        '.resources-content-cards__single-card-description-text'
      )
    };
    this.titleLimit = 60;
    this.descriptionLimit = 120;

    this.init();
  } //setupDefaults

  init() {
    const { $titles, $descriptions } = this.dom;

    this.updateContent({
      elements: $titles,
      limit: this.titleLimit,
      preventCutWord: false
    });

    this.updateContent({
      elements: $descriptions,
      limit: this.descriptionLimit,
      preventCutWord: false
    });
  } //init

  updateContent({ elements, limit, preventCutWord }) {
    try {
      for (const $title of elements) {
        const string = $title.textContent?.trim();

        if (string) {
          const truncateText = truncate({
            string,
            limit,
            preventCutWord
          });

          $title.innerHTML = truncateText;
        }
      }
    } catch (error) {
      return;
    }
  } //updateContent
}

export default Module;
